import { render, staticRenderFns } from "./GestaoAprovacao.vue?vue&type=template&id=3730f2e7&"
import script from "./GestaoAprovacao.vue?vue&type=script&lang=js&"
export * from "./GestaoAprovacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/spa/gestao-aprovacao/GestaoAprovacao.vue
// module id = 1397
// module chunks = 28